import { api } from '../lib/api';

export interface FortnoxOverviewError {
  section: string;
  message: string;
}

export interface FortnoxOverviewSummary {
  invoicedTotal: number;
  invoicedNet: number;
  invoicedVat: number;
  paidInPeriod: number;
  customerReceivables: number;
  customerOverdue: number;
  supplierInvoiceTotal: number;
  supplierInvoiceNet: number;
  supplierInvoiceVat: number;
  supplierDebt: number;
  supplierOverdue: number;
  estimatedCashResult: number;
  invoiceCount: number;
  supplierInvoiceCount: number;
}

export interface FortnoxAccountingSummary {
  rawRevenueAccounts: number;
  rawCostAccounts: number;
  revenue: number;
  costs: number;
  result: number;
}

export interface FortnoxOverviewRow {
  documentNumber: string;
  date: string;
  dueDate: string;
  name: string;
  total: number;
  balance: number;
  cancelled: boolean;
}

export interface FortnoxOverview {
  connected: boolean;
  from: string;
  to: string;
  tokenScope?: string | null;
  configuredScopes?: string | null;
  errors: FortnoxOverviewError[];
  summary?: FortnoxOverviewSummary;
  accounting?: FortnoxAccountingSummary;
  recentInvoices?: FortnoxOverviewRow[];
  recentSupplierInvoices?: FortnoxOverviewRow[];
}

export const fortnoxOverviewApi = {
  get: (from: string, to: string) =>
    api.get<FortnoxOverview>(`/fortnox/overview?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`),
};
